export enum GroupTelemetryKeys {
  NoOfGroupMapping = 'IAM_noOfGroupMapping',
  NoOfUsersAdded = 'IAM_noOfUsersAdded',
  NoOfRolesAssigned = 'IAM_noOfRolesAssigned',
  GroupType = 'IAM_groupType',
  ErrorReason = 'IAM_errorReason',
  ErrorCode = 'IAM_errorCode',
  ErrorEvent = 'IAM_isErrorEvent',
  TargetObjectId = 'IAM_targetObjectId',
}

export type TelemetryKeys = GroupTelemetryKeys;

export type GroupTelemetryValues = string | number | boolean;

export const TRUE_VALUE = true;
export const FALSE_VALUE = false;
export const UNKNOWN_ERROR = 'Unknown error';
export const NETWORK_ERROR = 'Network Error';
